<template>
  <section class="section-index-table">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="restrictions-settings align-items-end">
              <div class="col-3">
                <flat-pickr
                    v-model="dateTimeRange"
                    :config="pickerConfig"
                    class="form-control"
                    placeholder="Выберите дату"
                    name="date"></flat-pickr>
              </div>
              <div class="col-12 col-md-auto">
                <div class="confirm-restrictions">
                  <div class="confirm confirm-restrictions__button" @click="getRestrictionsHistory()">Просмотр истории</div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 index-table-col">
          <table v-if="restrictions !== null" class="index-table restriction-table">
            <tr>
              <th :class="sortClass('stationName')" @click="sortField('stationName')"><span>Фотогальваническая система</span></th>
              <th class="sort-disabled"><span>Ограничение kW</span></th>
              <th class="sort-disabled"><span>Ограничение %</span></th>
              <th :class="sortClass('date')" @click="sortField('date')"><span>Когда внесено</span></th>
              <th :class="sortClass('user')" @click="sortField('user')"><span>Пользователь</span></th>
              <th class="sort-disabled"><span>Успешно</span></th>
            <tr v-for="stationTable in sortedRestrictions" v-bind:key="stationTable.id">
              <td>
                <a href="#">
                  {{ stationTable.stationName }}
                </a>
              </td>
              <td>
                <div><span>Ограничение kW</span><b></b><i>
                  {{ String(stationTable.value) }}
                </i></div>
              </td>
              <td><div><span>Ограничение %</span><b></b><i>
              {{calculateRestrictionPercent(stationTable.stationPower, stationTable.value)}}
              </i></div></td>
              <td>
                <div><span>Дата и время</span><b></b><i>
                  {{ formatDateTime(stationTable.date) }}
                </i></div>
              </td>
              <td>
                <div><span>Пользователь</span><b></b>
                  <i v-if="stationTable.user !== null">
                  {{ stationTable.user }}
                  </i>
                  <i v-else style="color: gray; font-style: italic">
                    (не задано)
                  </i>
                </div>
              </td>
              <td>
                <div><span>Успешно</span><b></b><i>
                  {{ stationTable.success ? 'Да' : 'Нет' }}
                </i></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StationAPI from '@/api/station'
import moment from 'moment'
import collection from 'lodash/collection'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'
import '@/assets/css/_flatpickr.scss'

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
// date user stationName
export default {
  name: 'RestrictionsHistoryTable',
  data () {
    return {
      restrictions: null,
      dateTimeRange: null,
      dateFrom: null,
      dateTo: null,
      sort: {
        field: null,
        order: null
      },
      pickerConfig: {
        dateFormat: 'd.m.y',
        mode: 'range',
        onChange: this.pickerChange,
        maxDate: new Date(),
        locale: {
          rangeSeparator: ' - '
        }
      }
    }
  },
  components: { flatPickr },
  computed: {
    user () {
      return this.$store.getters[ 'user/hasUser' ] ? this.$store.getters[ 'user/user' ] : {
        isSuper: false
      }
    },
    sortedRestrictions () {
      if (this.sort.field !== null) {
        return collection.orderBy(this.restrictions, [this.sort.field], [this.sort.order])
      } else {
        return this.restrictions
      }
    }
  },
  methods: {
    sortField (field) {
      if (this.sort.field === field) {
        if (this.sort.order === 'asc') {
          this.sort.order = 'desc'
        } else if (this.sort.order === 'desc') {
          this.sort.field = null
          this.sort.order = null
        } else {
          console.error('Wrong sort order parameter')
        }
      } else {
        this.sort.field = field
        this.sort.order = 'asc'
      }
    },
    sortClass (field) {
      if (this.sort.field === field) {
        if (this.sort.order === 'asc') {
          return 'sort-ask'
        } else if (this.sort.order === 'desc') {
          return 'sort-desk'
        } else {
          console.error('Wrong sort order parameter')
          return 'no-sort'
        }
      } else {
        return 'no-sort'
      }
    },
    calculateRestrictionPercent (power, value) {
      return this.round(value / (parseFloat(String(power).replace(',', '.')) * 10))
    },
    round (val) {
      return Math.round(val)
    },
    formatDateTime (timestamp) {
      return moment.unix(timestamp)
        .format('DD/MM/YYYY HH:mm:ss')
    },
    pickerChange (selectedDates) {
      if (selectedDates[0] && selectedDates[1]) {
        this.dateFrom = moment(selectedDates[0]).hour(0).minute(0).second(0).utc().format(DATE_TIME_FORMAT)
        this.dateTo = moment(selectedDates[1]).hour(23).minute(59).second(59).utc().format(DATE_TIME_FORMAT)
      }
    },
    getRestrictionsHistory () {
      StationAPI.filterRestrictionHistory({
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      })
        .then((r) => {
          this.restrictions = r.data
        })
    }
  },
  created () {
    StationAPI.findRestrictionHistory()
      .then((r) => {
        this.restrictions = r.data
      })
  }
}
</script>

<style>
.index-table td div i.inv.warn b:first-child {
  background: #eabe43;
}
</style>
